<template>
    <div class="free-form">
        <div class="input">
            <input
                v-model="form.full_name"
                placeholder="Имя и фамилия"
                :class="{'bad-field':hasBadField('full_name')}">
        </div>
        <div class="input" :class="{'bad-field':hasBadField('full_name')}">
            <DatePicker
                v-model="form.birthday"
                placeholder="Дата рождения"
                type="date"
                valueType="format"
                format="DD.MM.YYYY"
                lang="ru"
                :confirm="false"
            />
        </div>
        <div class="input">
            <input
                v-model="form.agent_full_name"
                placeholder="Контактное лицо"
                :class="{'bad-field':hasBadField('agent_full_name')}">
        </div>
        <div class="input wrapper-input__phone-field" :class="{'bad-field':hasBadField('agent_phone')}">
            <div class="phone-code">+7</div>
            <input
                autocomplete="tel"
                max-length="12"
                v-phone
                v-model="form.agent_phone"
                placeholder="Телефон контактного лица">
        </div>
        <SimpleSelect
            title="Площадка"
            :options="options.place_options"
            @change="form.place_id = $event"
            :input-class="{'bad-field':hasBadField('place_id')}"
        />
        <RadiogroupDropdown
            title="Направление"
            :options="options.direction_options"
            @change="form.directions_ids = $event"
            :input-class="{'bad-field':hasBadField('directions_ids')}"
        />
        <!--<RadiogroupDropdownSimple
            title="В какие дни Вам удобно?"
            :options="options.convenient_days"
            @change="form.convenient_days = $event"
            :input-class="{'bad-field':hasBadField('convenient_days')}"
        />
        <RadiogroupDropdownSimple
            title="В какое время Вам удобно заниматься?"
            :options="options.convenient_time"
            @change="form.convenient_time = $event"
            :input-class="{'bad-field':hasBadField('convenient_time')}"
        />-->
        <label class="checkbox dark mt-4 mb-5">
            <input v-model="agreement" type="checkbox">
            <span class="checkbox__text">
                Даю согласие на обработку персональных данных
            </span>
        </label>
        <button @click="sendFormData" class="btn-dark">
            <span>Отправить</span>
        </button>
        <Notifications :notifications="notifications"/>
    </div>
</template>

<script>
import fn from "../../js/fn";
import PhoneMask from "../vue-components/directives/PhoneMaskNotSeven";
import SimpleSelect from "../vue-components/SimpleSelect";
import RadiogroupDropdown from "../vue-components/RadiogroupDropdown";
import RadiogroupDropdownSimple from "../vue-components/RadiogroupDropdownSimple";
import Notifications from "../vue-components/Notifications";
import DatePicker from 'vue2-datepicker'; // https://github.com/mengxiong10/vue2-datepicker
import 'vue2-datepicker/locale/ru';

export default {
    name: "FormApp",
    components: { SimpleSelect,RadiogroupDropdown, RadiogroupDropdownSimple, Notifications, DatePicker },
    directives: {
        'phone': PhoneMask
    },
    data() {
        return {
            process: false,
            form: {
                full_name: null,
                birthday: null,
                agent_full_name: null,
                agent_phone: null,
                //convenient_days: null,
                //convenient_time: null,
                place_id: null,
                directions_ids: null,
            },
            options: {
                //convenient_days: null,
                //convenient_time: null,
                place_options: null,
                direction_options: null,
            },
            notifications: [],
            agreement: false,
        }
    },
    mounted() {
        fn.sync({
            url: '/zen/project/api/free:mount',
            then: response => {
                //this.options.convenient_days = response.convenient_days
                //this.options.convenient_time = response.convenient_time
                this.options.place_options = response.place_options
                this.options.direction_options = response.direction_options
            }
        })
    },
    methods: {
        resetForm()
        {
            this.form = {
                full_name: null,
                birthday: null,
                agent_full_name: null,
                agent_phone: null,
                convenient_days: null,
                convenient_time: null,
                place_id: null,
                directions_ids: null,
            }

            this.agreement = false
        },
        sendFormData()
        {
            if (this.process) {
                return
            }

            if (!this.agreement) {
                this.notifications.push({
                    text: 'Не подтверждено согласие на обработку персональных данных',
                    type: 'danger',
                    field: null
                })
                return;
            }

            this.process = true
            this.notifications = []

            fn.sync({
                url: '/zen/project/api/free:send',
                data: { form:this.form },
                then: response => {
                    this.process = false
                    this.notifications = response.notifications
                    if (response.success) {
                        this.resetForm()
                    }
                },
                error: error => {
                    this.process = false
                }
            })
        },
        hasBadField(field)
        {
            return !!this.notifications.find(notification => {
                return notification.field === field
            })
        }
    }
}
</script>
<style>
.bad-field {
    border-color: red!important;
}
.mx-datepicker {
    width: 100%;
}
.mx-input {
    background: #FFFFFF;
    border: 1px solid #01002C;
    height: 60px;
    border-radius: 2px;
    padding: 5px 18px;
    box-shadow: none;
    font-size: inherit;
    line-height: inherit;
}
.bad-field .mx-datepicker input.mx-input {
    border-color: red!important;
}
</style>
